import React, { useEffect, useState } from 'react';
// import { useDispatch } from "react-redux";
// import { findDevice } from '../_actions/user_action';
import setting from '../config/setting';

import { CustomOverlayMap, Map, MapMarker } from 'react-kakao-maps-sdk';

// import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import '../css_admin/Overlay.css';

import MARKER_SRC_ONLINE from '../components/images/marker/marker_online.png';
// import MARKER_SRC_OFFLINE from '../components/images/marker/marker_offline.png';
// import MARKER_SRC_ERROR from '../components/images/marker/marker_error.png';
// import MARKER_SRC_READY from '../components/images/marker/marker_ready.png';

const key = require('../config/key');

const MapContainer_Customer = (props) => {
    // const dispatch = useDispatch();
    const userInfo = props.userInfo;
    const [overlayInfo, setOverlayInfo] = useState(null);

    const [isVisible, setIsVisible] = useState(false);

    const imageSize = { width: 20, height: 30 };
    const imageOption = { offset: { x: 18, y: 36 } };

    useEffect(() => {
        if (userInfo) {
            displayMap();
        }
    }, [userInfo]);

    /**
     * 주소 문자열을 위경도 좌표로 변환합니다.
     * @param {string} address - 변환할 주소 (예: "서울특별시 중구 세종대로 110")
     * @returns {Promise<{ lat: number, lng: number }>} 
     *   성공 시 { lat: 위도, lng: 경도 } 객체, 실패 시 null 반환
     */
    const getCoordsFromAddress = async (address) => {
        try {
        const response = await fetch(
            `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURIComponent(address)}`,
            {
                method: "GET",
                headers: {
                    "Authorization": `KakaoAK ${key.KAKAO_APP_KEY}`
                }
            }
        );
    
        const data = await response.json();
        // 문서가 하나라도 있으면 첫 번째 결과의 x, y 사용
        if (data.documents && data.documents.length > 0) {
            const doc = data.documents[0];
            return {
            lat: parseFloat(doc.y),   // 위도
            lng: parseFloat(doc.x)    // 경도
            };
        }
        } catch (error) {
        console.error("좌표 변환 오류:", error);
        }
        return null;
    };
    
    // 사용 예시
  
    const displayMap = () => {
        // const body = {
        //     id: userInfo.email,
        //     sensorNumber: userInfo.sensorMain
        // };

        (async () => {
            const address = "경기 평택시 고덕중앙로 200-4";
            const coords = await getCoordsFromAddress(address);
            if (coords) {
                console.log(`위도: ${coords.lat}, 경도: ${coords.lng}`);

                const info = {
                    mID: 1,
                    mLat: coords.lat,
                    mLng: coords.lng,
                    mAddress: "경기 평택시 고덕중앙로 200-4",
                    mSensor: '',
                    mMarkerImage: MARKER_SRC_ONLINE
                };

                setOverlayInfo(info);
            } else {
                console.log("해당 주소의 좌표를 찾을 수 없습니다.");
            }
        })();
    };

    const EventOverlayContainer = ({ position }) => {
        const totalAddress = overlayInfo.mAddress;
        const arrayAddress = totalAddress.split(" ");
        let line1Address = arrayAddress.slice(0, 3).join(" ");
        line1Address = "경기 평택시 고덕중앙로 200-4";
        let line2Address = totalAddress.substring(line1Address.length);
        let line3Address = "";
        if (line2Address.includes('(')) {
            const [partAddress] = line2Address.split("(");
            line2Address = partAddress;
            line3Address = line2Address.substring(line2Address.length);
        }
        line2Address = "(고덕동, 우성고덕타워)";
        line3Address = "";

        return (
            <>
                <MapMarker
                    key={`${overlayInfo.mID}-${overlayInfo.mLat}-${overlayInfo.mLng}`}
                    position={position}
                    image={{
                        src: overlayInfo.mMarkerImage,
                        size: imageSize,
                        options: imageOption
                    }}
                    onClick={() => setIsVisible(prev => !prev)} />

                <CustomOverlayMap position={position}>
                    {isVisible && (
                        <div className="mapMarkerPopup" style={{ height: '210px' }}>
                            <div className="mapMarkerPopupLayer">
                                <div className="modalCloseIcon">
                                    <div className="modalCloseIconImg" onClick={() => setIsVisible(false)}></div>
                                </div>
                                <div><h2>SEMIQUZ</h2></div>
                                <br />
                                <hr />
                                <div className="PopuptextareaId">
                                    <div className="PopuptextareaIdTitle">전화번호 : </div>
                                    <div className="PopuptextareaIdText">070-4352-0624</div>
                                </div>
                                <div className="PopuptextareaLocation">
                                    <div className="PopuptextareaIdTitle">주소 : </div>
                                    <div className="PopuptextareaIdText">{line1Address}</div>
                                    <div className="PopuptextareaIdText">{line2Address}</div>
                                    <div className="PopuptextareaIdText">{line3Address}</div>
                                </div>
                            </div>
                        </div>
                    )}
                </CustomOverlayMap>
            </>
        );
    };

    return (
        <div className="mapContainer">
            {overlayInfo && (
                <Map
                    center={{
                        lat: setting.map_center_latitude,
                        lng: setting.map_center_longitude
                    }}
                    className="mapResponsive"
                    level={setting.map_level}
                    onClick={() => setIsVisible(false)}
                >
                    <EventOverlayContainer
                        key={`EventMarkerContainer-${overlayInfo.mLat}-${overlayInfo.mLng}`}
                        position={{ lat: overlayInfo.mLat, lng: overlayInfo.mLng }}
                    />
                </Map>
            )}
        </div>
    );
};

export default MapContainer_Customer;
